import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { ProcessChainSchema } from '../../entities/process-chain/process-chain.schema';
import { ProcessCategorySchema } from '../../entities/process/process.schema';
// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
/**
 * List Process Chains Request Schema (query params)
 * GET /api/v2/process-chains
 */ export const ListProcessChainsRequestSchema = z.object({
    category: ProcessCategorySchema.optional(),
    parentChainId: z.string().nullable().optional()
});
/**
 * List Process Chains Response Schema
 */ export const ListProcessChainsResponseSchema = z.object({
    processChains: z.array(ProcessChainSchema.extend({
        processCount: z.number().int(),
        childCount: z.number().int()
    }))
});
export const ListProcessChainsErrorSchema = BaseErrorSchema;

//# sourceMappingURL=list-process-chains.schema.js.map